import { withFlexProps } from '@hocs';
import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { arrayOf, func, shape, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useIndexedDB } from 'react-indexed-db-hook';
// import { useOnlineStatusDetector } from 'src/hooks/useOnlineStatusDetector';

const ScenarioCard = ({
  cardContent,
  onNextButtonClick,
  progress,
  setValidatedAnswers,
}) => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();
  // const { isOnline } = useOnlineStatusDetector();
  const [shouldShowTitleCard, setShouldShowTitleCard] = useState(true);
  const [isCorrectAnswer, setIsCorrectAnswer] = useState(false);
  const [incorrectAnswersCount, setIncorrectAnswersCount] = useState(0);
  const [chosenOptionId, setChosenOptionId] = useState(null);

  // const [offlineImage, setOfflineImage] = useState(null);
  // const { getAll } = useIndexedDB('image');
  // useEffect(() => {
  //   const init = async () => {
  //     const allImages = await getAll();
  //     const file = allImages.find(
  //       (el) => el.url === cardContent?.background_image_url
  //     )?.file;
  //     if (file) {
  //       setOfflineImage(URL.createObjectURL(file));
  //     }
  //   };
  //   if (!isOnline) {
  //     init();
  //   }
  // }, [isOnline]);

  useEffect(() => {
    setShouldShowTitleCard(true);
  }, [cardContent]);

  const handleOptionPress = (isCorrectOption, optionId) => () => {
    setShouldShowTitleCard(false);
    setChosenOptionId(optionId);
    setIsCorrectAnswer(isCorrectOption);
    setValidatedAnswers((prevState) =>
      prevState
        ? [
            ...prevState.filter((answer) => answer.id !== cardContent.id),
            { id: cardContent.id, is_correct: isCorrectOption },
          ]
        : [{ id: cardContent.id, is_correct: isCorrectOption }]
    );
  };

  const handleNextButtonClick = () => {
    setIncorrectAnswersCount(0);
    onNextButtonClick();
  };

  const handleTryAgainButtonClick = () => {
    setIncorrectAnswersCount((prevState) => prevState + 1);
    setShouldShowTitleCard(true);
  };

  return shouldShowTitleCard ? (
    <Flex width="100%">
      <Flex flexDirection="column" mr={isTabletSM ? 0 : 10}>
        <Flex
          backgroundColor={theme.colors.white[20]}
          flexDirection="column"
          mb={1}
          p={32}
          {...(isTabletSM && {
            px: 16,
            py: 24,
          })}
        >
          <Typography
            color={theme.colors.white[100]}
            variant={
              isTabletSM ? 'MS-semibold-s18-lh27' : 'MS-semibold-s24-lh30'
            }
          >
            {cardContent?.description}
          </Typography>
          <Typography color={theme.colors.white[60]} variant="MS-bold-s14-lh22">
            {cardContent?.question}
          </Typography>
        </Flex>
        <Flex flexDirection="column" gap={3}>
          {cardContent?.options.map((option) => (
            <Button
              key={option.id}
              border="none"
              borderRadius={0}
              height="auto"
              justifyContent="flex-start"
              onClick={handleOptionPress(option.is_correct, option.id)}
              px={32}
              py={25}
              {...(isTabletSM && { p: 16 })}
              variant="secondary"
              width="100%"
            >
              <Typography
                color={theme.colors.white[100]}
                textAlign="left"
                variant={
                  isTabletSM ? 'MS-regular-s16-lh25' : 'MS-semibold-s18-lh27'
                }
              >
                {option.statement}
              </Typography>
            </Button>
          ))}
        </Flex>
      </Flex>
      {/* {!isTabletSM && (
        <Flex
          backgroundImage={
            isOnline ? cardContent?.background_image_url : offlineImage
          }
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          height="100%"
          maxWidth={isLaptop ? 239 : 338}
          width="100%"
        />
      )} */}
    </Flex>
  ) : (
    <Flex flexDirection="column" width="100%">
      <Flex
        backgroundColor={theme.colors.hunterGreen[90]}
        borderColor={theme.colors.whiteLine[100]}
        borderStyle="solid"
        borderWidth={1}
        flex={1}
        flexDirection="column"
        mb={24}
        minHeight={320}
        position="relative"
        pt={32}
        px={24}
      >
        {progress && (
          <Typography
            color={theme.colors.white[60]}
            position="absolute"
            right={16}
            textAlign="right"
            top="8px"
            variant="MS-regular-s20-lh31"
          >
            {progress}
          </Typography>
        )}
        <Typography
          color={
            isCorrectAnswer ? theme.colors.brightGreen : theme.colors.red[100]
          }
          mb={3}
          variant="MS-dark-s16-lh17"
        >
          {isCorrectAnswer
            ? i18n.t('ScenarioPage.Correct').toUpperCase()
            : i18n.t('ScenarioPage.Incorrect').toUpperCase()}
        </Typography>
        <Typography
          color={theme.colors.white[100]}
          textAlign="justify"
          variant="MS-regular-s18-lh22"
        >
          {
            cardContent?.options.find((option) => option.id === chosenOptionId)
              ?.explanation
          }
        </Typography>
      </Flex>
      <Flex gap={16} justifyContent="space-between" width="100%">
        {incorrectAnswersCount >= 2 && !isCorrectAnswer ? (
          <>
            <Button
              maxWidth={395}
              onClick={handleTryAgainButtonClick}
              variant="primary"
              whiteSpace="nowrap"
              width="100%"
            >
              <Typography
                color={theme.colors.black[100]}
                variant="MS-semibold-s16-lh25"
              >
                {i18n.t('ScenarioPage.TryAgain').toUpperCase()}
              </Typography>
            </Button>
            <Button
              maxWidth={395}
              onClick={handleNextButtonClick}
              variant="secondary"
              whiteSpace="nowrap"
              width="100%"
            >
              <Typography variant="MS-semibold-s16-lh25">
                {i18n.t('ScenarioPage.Skip').toUpperCase()}
              </Typography>
            </Button>
          </>
        ) : (
          <Button
            maxWidth={395}
            onClick={
              isCorrectAnswer
                ? handleNextButtonClick
                : handleTryAgainButtonClick
            }
            variant={isCorrectAnswer ? 'primary' : 'secondary'}
            whiteSpace="nowrap"
            width="100%"
          >
            <Typography
              color={
                isCorrectAnswer
                  ? theme.colors.black[100]
                  : theme.colors.white[100]
              }
              variant="MS-semibold-s16-lh25"
            >
              {isCorrectAnswer
                ? i18n.t('ScenarioPage.Next').toUpperCase()
                : i18n.t('ScenarioPage.TryAgain').toUpperCase()}
            </Typography>
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

ScenarioCard.propTypes = {
  cardContent: shape({
    choosingOptions: arrayOf(
      shape({
        id: string,
        titleText: string,
      })
    ),
    correctAnswer: string,
    correctDescription: string,
    icorrectDescription: string,
    image: string,
    subtitleText: string,
    titleText: string,
  }).isRequired,
  onNextButtonClick: func.isRequired,
  progress: string,
  setValidatedAnswers: func.isRequired,
};

ScenarioCard.defaultProps = {
  progress: null,
};

export default withFlexProps(ScenarioCard);
